export const FETCH_LIMITED_SERVICE_AVAILABILITY_FAILURE = "FETCH_LIMITED_SERVICE_AVAILABILITY_FAILURE";
export const FETCH_LIMITED_SERVICE_AVAILABILITY_REQUEST = "FETCH_LIMITED_SERVICE_AVAILABILITY_REQUEST";
export const FETCH_LIMITED_SERVICE_AVAILABILITY_SUCCESS = "FETCH_LIMITED_SERVICE_AVAILABILITY_SUCCESS";
